import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { CloudData } from 'angular-tag-cloud-module';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import {
  MAX_CLOUD_WORDS,
  WordCloudComponent,
} from '../../shared/components/word-cloud/word-cloud.component';
import { WordTableComponent } from '../../shared/components/word-table/word-table.component';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-word-cloud',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [
    CommonModule,
    PrintFilterDataComponent,
    WordCloudComponent,
    WordTableComponent,
  ],
  templateUrl:
    '../../main/report/report-data/wordcloud/wordcloud.component.html',
  styleUrl: '../../main/report/report-data/wordcloud/wordcloud.component.scss',
  styles: [
    `
      :host.embedded app-print-filter-data {
        display: none;
      }
    `,
  ],
})
export class PrintWordCloudComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  embedded = input(false);
  embeddedData = input<CloudData[] | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);
  embeddedTitle = input<string>('');

  print = true;
  private readonly titleService = inject(Title);

  filter!: IReportFilter;
  data: CloudData[] = [];
  dataChart: CloudData[] = [];

  count = 0;
  title = '';

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.data = this.embeddedData() ?? [];
      this.dataChart = this.data.slice(0, MAX_CLOUD_WORDS);
      this.filter = this.embeddedFilter() as IReportFilter;
      this.title = this.embeddedTitle();
      this.count = 0;

      this.data.forEach((data) => {
        this.count = this.count + data.weight;
      });

      return;
    }

    const { data, filter, title } = this.activatedRoute.snapshot.data['data'];

    this.data = data as CloudData[];
    this.dataChart = this.data.slice(0, MAX_CLOUD_WORDS);
    this.filter = filter;
    this.title = title;

    this.data.forEach((data) => {
      this.count = this.count + data.weight;
    });

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório wordcloud',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }

  openModal(cloudData: CloudData): void {
    console.log(`${cloudData.text} - ${cloudData.weight}`);
  }
}
